/* src/app/private/components/sales-mail-hub/mail-middle-section/mail-middle-section.component.scss */
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.animate-bounce-delay {
  animation: bounce 1.4s infinite ease-in-out both;
}
.animate-bounce-delay200 {
  animation: bounce 1.4s infinite ease-in-out 0.2s both;
}
.animate-bounce-delay400 {
  animation: bounce 1.4s infinite ease-in-out 0.4s both;
}
/*# sourceMappingURL=mail-middle-section.component.css.map */
